export function createUseAuth(supabase, hooks) {
    const { useEffect, useState } = hooks;
    return function useAuth() {
        const [session, setSession] = useState(null);
        const [isLoading, setIsLoading] = useState(true);
        useEffect(() => {
            let isActive = true;
            supabase.auth
                .getSession()
                .then(({ data }) => {
                if (!isActive)
                    return;
                setSession(data.session ?? null);
            })
                .finally(() => {
                if (!isActive)
                    return;
                setIsLoading(false);
            });
            const { data } = supabase.auth.onAuthStateChange((_event, nextSession) => {
                setSession(nextSession);
            });
            return () => {
                isActive = false;
                data.subscription.unsubscribe();
            };
        }, []);
        return { session, user: session?.user ?? null, isLoading };
    };
}
